module.exports = __webpack_public_path__ + "img/en.e6679990.png";